import React, { useMemo, useState } from 'react';
import { Reviewlink } from '@cube3/common/model/resource-types';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { createContext } from 'react';

interface ReviewViewContextType {
  reviewLink: Reviewlink;
  activeAsset: Asset;
  setActiveAsset?: (asset: Asset) => void;
  email: string;
  userImage?: string;
  //close comment section on mobile
  setOpenCommentBar?: (boolean) => void
}

export const ReviewViewContext = createContext<ReviewViewContextType>(null);

//for mobile
export const ReviewSliderBarContext = createContext<{
  itemType: string;
  itemClicked: (type: string) => void;
}>(null);

export const ReviewsActiveTabContext = createContext<{
  activeTab: number;
  setActiveTab: (index: number) => void;
}>(null);

export const ReviewsActiveTabContextProvider = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const context = useMemo(
    () => ({ activeTab, setActiveTab }),
    [{ activeTab, setActiveTab }]
  );

  return (
    <ReviewsActiveTabContext.Provider value={context}>
      {props.children}
    </ReviewsActiveTabContext.Provider>
  );
};
